import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Route(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Route", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14 4c-2.1217 0-4.15656.84285-5.65685 2.34315C6.84285 7.84344 6 9.87827 6 12c0 4.92 6.18 9.2 6.9 9.66.3266.2151.709.3297 1.1.3297.391 0 .7734-.1146 1.1-.3297.72-.46 6.9-4.74 6.9-9.66 0-2.12173-.8429-4.15656-2.3431-5.65685C18.1566 4.84285 16.1217 4 14 4Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M40 44H10c-1.5913 0-3.11742-.6321-4.24264-1.7574C4.63214 41.1174 4 39.5913 4 38c0-1.5913.63214-3.1174 1.75736-4.2426C6.88258 32.6321 8.4087 32 10 32h10c.5304 0 1.0391-.2107 1.4142-.5858S22 30.5304 22 30c0-.5304-.2107-1.0391-.5858-1.4142S20.5304 28 20 28h-8c-.5304 0-1.0391-.2107-1.4142-.5858S10 26.5304 10 26c0-.5304.2107-1.0391.5858-1.4142S11.4696 24 12 24h8c1.5913 0 3.1174.6321 4.2426 1.7574C25.3679 26.8826 26 28.4087 26 30c0 1.5913-.6321 3.1174-1.7574 4.2426C23.1174 35.3679 21.5913 36 20 36H10c-.53043 0-1.03914.2107-1.41421.5858C8.21071 36.9609 8 37.4696 8 38c0 .5304.21071 1.0391.58579 1.4142C8.96086 39.7893 9.46957 40 10 40h30c.5304 0 1.0391.2107 1.4142.5858S42 41.4696 42 42c0 .5304-.2107 1.0391-.5858 1.4142S40.5304 44 40 44Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M38 38c-.5304 0-1.0391-.2107-1.4142-.5858S36 36.5304 36 36v-4c0-.5304.2107-1.0391.5858-1.4142S37.4696 30 38 30c.5304 0 1.0391.2107 1.4142.5858S40 31.4696 40 32v4c0 .5304-.2107 1.0391-.5858 1.4142S38.5304 38 38 38Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M38 32c3.3137 0 6-2.6863 6-6s-2.6863-6-6-6-6 2.6863-6 6 2.6863 6 6 6Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12.4674 15.7039c.4851.1985 1.0044.2991 1.5284.296 1.0541-.0147 2.0637-.4278 2.8266-1.1566.3731-.3708.6693-.8119.8714-1.2979.2021-.486.3062-1.0073.3062-1.5338s-.1041-1.0479-.3062-1.5339c-.2021-.48599-.4983-.92711-.8714-1.29788-.5569-.56247-1.2683-.94608-2.0436-1.1019-.7753-.15583-1.5794-.07681-2.3097.22697s-1.3538.81856-1.7909 1.47872c-.4371.66019-.6681 1.43579-.6635 2.22799-.01959.2655-.01959.5321 0 .7976.0685.2544.1759.4965.3184.7179.0796.2451.2008.4745.3583.6781.1376.2281.2977.4419.4778.6381.372.3697.8132.6621 1.2982.8606Z",
        fill: theme.vars.palette.secondary.main
      }
    )
  ] });
}
Route.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Route"
};
validateTidalLicense();
export {
  Route
};
//# sourceMappingURL=Route.js.map
